<template>
  <select :value="value" @change="input" v-on="listeners">
    <optgroup :label="`Fade ${compDirection}`">
      <option :value="`fade ${direction}`">Fade {{ direction }}</option>
    </optgroup>
    <optgroup :label="`Slide ${compDirection}`">
      <option :value="`slide ${direction} hval`"
        >Slide {{ direction }} horizontally</option
      >
      <option :value="`slide ${direction} vval`"
        >Slide {{ direction }} vertically</option
      >
      <option :value="`slide ${direction} dval`"
        >Slide {{ direction }} diagonally</option
      >
    </optgroup>
    <optgroup :label="`Bounce ${compDirection}`">
      <option :value="`bounce ${direction} hval`"
        >Bounce {{ direction }} horizontally</option
      >
      <option :value="`bounce ${direction} vval`"
        >Bounce {{ direction }} vertically</option
      >
      <option :value="`bounce ${direction} dval`"
        >Bounce {{ direction }} diagonally</option
      >
    </optgroup>
    <optgroup :label="`Grow ${compDirection}`">
      <option :value="`grow ${direction} hval`"
        >Grow {{ direction }} horizontally</option
      >
      <option :value="`grow ${direction} vval`"
        >Grow {{ direction }} vertically</option
      >
      <option :value="`grow ${direction} dval`"
        >Grow {{ direction }} diagonally</option
      >
    </optgroup>
  </select>
</template>

<script>
import BaseSelect from "./BaseSelect";

export default {
  name: "AnimationSelect",
  extends: BaseSelect,
  props: {
    direction: {
      type: String,
      required: true
    }
  },
  computed: {
    compDirection() {
      if (this.direction === "in") return "entrances";
      return "exits";
    }
  }
};
</script>

<style lang="css"></style>
